import { render, staticRenderFns } from "./CytomineModal.vue?vue&type=template&id=4c8ab54c"
import script from "./CytomineModal.vue?vue&type=script&lang=js"
export * from "./CytomineModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports